
:host {
  display: content;
  position: absolute;
}

@define-mixin before {
  content: "";
  width: 11px;
  height: 11px;
  background: var(--primary);
  position: absolute;
  border-radius: 2px;
}

.hd-tooltip {
  display: flex;
  align-items: center;
  background: var(--primary);
  border-radius: 4px;
  width: calc(100% - 32px);
  padding: 8px 24px 8px 10px;
  z-index: 0;
  color: #fff;
  position: relative;
  min-height: 80px;

  &.afd-hide {
    display: none
  }

  &.hd-tooltip-top-left:before {
    @mixin before;
    width: 11px;
    height: 11px;
    background: var(--primary);
    position: absolute;
    border-radius: 2px;
    top: -4px;
    left: 16px;
    transform: rotate(45deg);

    @media(min-width: 1040px) {
      left: 29px
    }
  }

  &.hd-tooltip-top-right:before {
    @mixin before;
    top: -4px;
    right: 16px;
    transform: rotate(45deg);

    @media(min-width: 1040px) {
      right: 29px
    }
  }

  &.hd-tooltip-top-left:before {
    @mixin before;
    top: -4px;
    left: 16px;
    transform: rotate(45deg);

    @media(min-width: 1041px) {
      left: 29px
    }
  }

  &.hd-tooltip-bottom-left:before {
    @mixin before;
    bottom: -4px;
    left: 16px;
    transform: rotate(45deg);

    @media(min-width: 1041px) {
      left: 29px
    }
  }

  &.hd-tooltip-bottom-middle:before {
    @mixin before;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }
  
  &.hd-tooltip-top-middle:before {

    @mixin before;
    top: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }

  &.hd-tooltip-left-top:before {
    @mixin before;
    left: -4px;
    top: 10px;
    transform: rotate(45deg);
  }

  &__close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;

    &:hover {
      opacity: .5
    }
  }

  & slot[name=image] > img {
    width: 66px;
    height: 67px;
    margin-right: 8px;

    &-cn {
      height: 48px;
      width: auto;
      margin: 0 16px 0 8px;
    }
  }

  .hd-tooltip-content {
    font-size: 12px;
    color: white;
    text-align: left;
    line-height: normal;

    strong {
      font-weight: 600
    }
    
    .hd-tooltip-link {
      font-size: 14px;
      font-weight: 600;
      margin-top: 4px;
      color: white;
      display: block;

      &:hover {
        text-decoration: underline;
        color: white
      }
    }
  }

  @media(min-width: 768px) {
    width: 310px;
  }
}